export function formatarData(iso: string | null | undefined): string {
  if (!iso) return "—";
  const data = new Date(iso);
  return Number.isNaN(data.getTime()) ? iso : data.toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
}

export function formatarQuantidade(valor: number): string {
  return valor.toLocaleString("pt-BR", { maximumFractionDigits: 4 });
}

/** "12,5" ou "12.5" → 12.5 (campos preenchidos no padrão BR). */
export function lerNumero(texto: string, padrao = 0): number {
  const numero = Number.parseFloat((texto || "").replace(",", "."));
  return Number.isFinite(numero) ? numero : padrao;
}

export function Carregando() {
  return <p className="carregando">Carregando…</p>;
}

export function ErroCarregamento({ erro }: { erro: unknown }) {
  const mensagem = erro instanceof Error ? erro.message : "Não foi possível carregar.";
  return <div className="flash erro">{mensagem}</div>;
}

export function Tabela({ children }: { children: React.ReactNode }) {
  return (
    <div className="tabela-rolagem">
      <table>{children}</table>
    </div>
  );
}

/** Atributos que evitam o autocompletar/gerenciadores de senha em campos de busca. */
export const semAutocompletar = {
  autoComplete: "off",
  autoCorrect: "off",
  autoCapitalize: "off",
  spellCheck: false,
  "data-lpignore": "true",
  "data-1p-ignore": "",
} as const;
